import { createAsyncThunk } from "@reduxjs/toolkit";

import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_ALL_CUSTOMER_ACTIVITY,
  API_GET_ALL_CUSTOMER_ACTIVITY_BY_DATE_RANGE,
} from "../../Apis/ApiEndPoints";
import { ICustomerAnalyticsResponse, IGetAllCustomerActivityByDateRangeRequestBody, IGetAllCustomerActivityRequestBody } from "../../models/admin/customerAnalytics/customerAnalytics";

export const getAllCustomerActivity = createAsyncThunk(
  "all/CustomerActivity",
  async (requestBody:IGetAllCustomerActivityRequestBody, { dispatch }) => {
    const response: ICustomerAnalyticsResponse = await CustomAction(
      Api.get(`${API_GET_ALL_CUSTOMER_ACTIVITY}/category?category=${requestBody.category}`),
      dispatch,
      "all/CustomerActivity"
    );
    return response;
  }
);

export const getAllCustomerActivityByDateRange = createAsyncThunk(
  "all/CustomerActivityByDateRange",
  async (requestParams:IGetAllCustomerActivityByDateRangeRequestBody, { dispatch }) => {
    let apiUrl = `${API_GET_ALL_CUSTOMER_ACTIVITY_BY_DATE_RANGE}?category=${requestParams?.category}&`;
    if (requestParams.fromDate) {
      apiUrl += `fromDate=${requestParams.fromDate}&`;
    }
    if (requestParams.toDate) {
      apiUrl += `toDate=${requestParams.toDate}&`;
    }

    apiUrl = apiUrl.endsWith("&") ? apiUrl.slice(0, -1) : apiUrl;

    const response: ICustomerAnalyticsResponse = await CustomAction(
      Api.get(apiUrl),
      dispatch,
      "all/CustomerActivityByDateRange"
    );
    return response;
  }
);
